import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const validateCreateForm = yup.object().shape({
  name: yup.string().required(LOCALE.name + LOCALE.required_field),
});
